import { render, staticRenderFns } from "./AddFeatureDialog.vue?vue&type=template&id=63085a94&"
import script from "./AddFeatureDialog.vue?vue&type=script&lang=js&"
export * from "./AddFeatureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports